export default __webpack_public_path__ + "static/media/NFT-file-logo.2e747f35.png";